import React from "react";
import PropTypes from "prop-types";
import Paper from "material-ui/Paper";
import { withStyles } from "material-ui/styles";
import isMobile from "ismobilejs";

const browserStyles = () => ({
  surveyStatusErrorWrapper: {
    width: 600,
    margin: "50px auto",
    padding: 20
  }
});

const mobileStyles = () => ({
  surveyStatusErrorWrapper: {
    margin: 20,
    padding: 20
  }
});

const message = authErrorType => {
  switch (authErrorType) {
    case "stateNotOpen":
      return "このアンケートは現在公開されていません。";
    case "canNotAnswer":
      return "このアンケートは既に終了したか、現在回答ができない状態です。";
    default:
      throw new Error(`予期しないauthErrorType: ${authErrorType}`);
  }
};

const AuthError = props => {
  const { classes, authErrorType } = props;
  // authErrorType がnullの場合は空のdivを表示する（データ取得前の表示）
  console.log("in AuthError authErrorType: ", authErrorType);

  return authErrorType ? (
    <Paper className={classes.surveyStatusErrorWrapper}>
      {message(authErrorType)}
    </Paper>
  ) : (
    <div />
  );
};

AuthError.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(
  AuthError
);



// WEBPACK FOOTER //
// ./src/components/answer/AuthError.jsx